import { cn } from "../../lib/utils";

export const STOCK_LABELS = {
  in_stock: "In Stock",
  out_of_stock: "Out of Stock",
  coming_soon: "Coming Soon",
};

const STOCK_STYLES = {
  in_stock: "bg-emerald-500/15 text-emerald-400 border-emerald-500/25",
  out_of_stock: "bg-firered/15 text-firered border-firered/25",
  coming_soon: "bg-amber/15 text-amber border-amber/25",
};

export function StockBadge({ status, className }) {
  return (
    <span
      data-testid={`stock-badge-${status}`}
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold border tracking-wide",
        STOCK_STYLES[status] || "bg-white/10 text-white/70 border-white/15",
        className
      )}
    >
      {STOCK_LABELS[status] || status}
    </span>
  );
}

export function formatGBP(n) {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n);
}
